export const APP_ENV_CONFIG = {
  'bulk-min': process.env.GATSBY_BULK_MIN ? parseInt(process.env.GATSBY_BULK_MIN) : 2,
  'bulk-max': process.env.GATSBY_BULK_MAX ? parseInt(process.env.GATSBY_BULK_MAX) : 100,
  'pre-select-threshold': process.env.GATSBY_PRE_SELECT_THRESHOLD ? parseInt(process.env.GATSBY_PRE_SELECT_THRESHOLD) : 10,
  'gst-percent': process.env.GATSBY_GST_PERCENT ? parseInt(process.env.GATSBY_GST_PERCENT) : 7,
  'add-on-limit': process.env.GATSBY_ADDON_LIMIT ? parseInt(process.env.GATSBY_ADDON_LIMIT) : 2,
  'penalty': 7 //will remove this line once penalty will be added in enviroment
};